<template lang="pug">
  //- VueDragResize(@resizing="resize" @dragging="resize"
    :w="width" :h="height" :x="left" :y="top"
    :isActive="activeDragResize")
  vue-draggable-resizable(v-if="imgURL"
    :w="width" :h="height" :x="left" :y="top" :z="201"
    :max-width="280" :max-height="280"
    :resizable="true"
    @dragging="onDrag" @resizing="onResize")
    div.item-preview-image.f.fh
      span(v-if="imgURL"
        @click.stop="onDrawHere").btn-set-here.fz14.cursor-pointer.px6 Draw
      div(v-if="imgURL" @click.stop="cancelTool").btn-cancel.cursor-pointer
        v-icon(size="20" color="#999") mdi-close
      img(v-if="imgURL"
        ref="previewImg" :src="imgURL"
        :class="`doodle-animation-${currentAnimation}`").object-fit-cover
      div.wrap-animation-selector
        AtomToolAnimationSelector(@setCurrentAnimation="setCurrentAnimation")
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.item-preview-image {
  position: relative;
  z-index: 101;
  width: 100%;
  height: 100%;
  .btn-set-here {
    position: absolute;
    left: 0;
    bottom: calc(100% + 4px);
    background: $active_color;
    border-radius: 3px;
    filter: $drop_shadow;
  }
  .btn-cancel {
    position: absolute;
    right: 0;
    bottom: calc(100% + 4px);
    color: $active_color;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .wrap-animation-selector {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    // right: 0;
  }
}
</style>

<script>
import database from '@/database'
// import VueDragResize from 'vue-drag-resize'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import AtomToolAnimationSelector from '@/components/atom/AtomToolAnimationSelector'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import { storage } from '@/components/utils/firebase'
import { Camera, CameraSource, CameraResultType } from '@capacitor/camera'

export default {
  components: {
    VueDraggableResizable,
    AtomToolAnimationSelector
    // VueDragResize
  },
  data () {
    return {
      takenPhoto: null,
      isUploading: false,
      imgURL: null,
      fileId: null,
      // width: 'auto', height: 'auto',
      width: 240, height: 240,
      maxw: 280, maxh: 280,
      top: 0, left: 0,
      activeDragResize: false,
      isSaving: false,
      currentAnimation: 'normal'
    }
  },
  props: {
    posForPreview: {
      type: Object,
      required: true
    },
    showingPage: {
      type: Object,
      required: true
    },
    slide: {
      type: Object,
      required: true
    },
    doodles: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    animatedDoodleNum () {
      return this.doodles.filter(e => e.animation && e.animation !== 'normal').length
    },
    personalMindoScore () {
      const myDoodles = this.doodles
        .filter(e => e.page === this.slide.currentPage)
        .filter(e => e.createdBy === this.uid)
      if (!myDoodles[0]) return 0
      const likeSum = myDoodles.map(d => d.likeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      const dislikeSum = myDoodles.map(d => d.dislikeNum)
        .reduce((sum, el) => { return sum + el }, 0)
      return likeSum - dislikeSum
    }
  },
  created () {
    // this.top = this.posForPreview.y - this.height/2
    // this.left = this.posForPreview.x - this.width/2

    // const slideImg = this.$parent.$refs.slideImg
    // this.top = this.posForPreview.y - slideImg.clientHeight
    // this.left = this.posForPreview.x
  },
  methods: {
    onResize (x, y, width, height) {
      this.left = x
      this.top = y
      this.width = width
      this.height = height
    },
    onDrag (x, y) {
      this.left = x
      this.top = y
    },
    async uploadPhoto () {
      this.takenPhoto = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Photos,
        // source: (this.content.type === 'photo') ? 
        //   CameraSource.Photos: CameraSource.Camera,
        webUseInput: true,
        saveToGallery: true
      })

      this.isUploading = true

      const base64 = this.takenPhoto.dataUrl
      this.resizeImage(base64, this.uploadImg)
    },
    resizeImage (base64image, callback) {
      let image = new Image()
      image.crossOrigin = 'Anonymous'
      image.onload = function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const THUMBNAIL_WIDTH = 120
        const THUMBNAIL_HEIGHT = 120

        let width, height, ratio
        if (image.width > image.height) {
          // 横長の画像は横のサイズを指定値にあわせる
          ratio = image.height / image.width
          width = THUMBNAIL_WIDTH
          height = THUMBNAIL_WIDTH * ratio
        } else {
          // 縦長の画像は縦のサイズを指定値にあわせる
          ratio = image.width / image.height
          width = THUMBNAIL_HEIGHT * ratio
          height = THUMBNAIL_HEIGHT
        }
        canvas.setAttribute('width', width)
        canvas.setAttribute('height', height)

        ctx.clearRect(0, 0, width, height)
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)        

        callback(canvas.toDataURL())
      }
      image.src = base64image
    },
    async uploadImg (base64) {
      this.fileId = this.getUniqueStr()
      let storageRef = storage.ref()
      const imgRef = storageRef.child(`USER/${this.uid}/DOODLE/${this.fileId}.${this.takenPhoto.format}`)
      const imgURL = await imgRef.putString(base64.split(',')[1], 'base64').then(async (snapshot) => {
        var url = await snapshot.ref.getDownloadURL().then(async (downloadURL) => {
          return downloadURL
        })
        return url
      })

      const rect = await this.getImageDimensions(base64)
      const slideImg = this.$parent.$refs.slideImg
      this.width = rect.w
      this.height = rect.h
      this.top = this.posForPreview.y - slideImg.clientHeight - rect.h/2
      this.left = this.posForPreview.x - rect.w/2

      console.log('imgURL:', imgURL)
      this.imgURL = imgURL
      this.isUploading = false
    },
    setExistingImg (imgURL) {
      console.log('[setExistingImg] setExistingImg:', imgURL)
      this.imgURL = imgURL
      this.fileId = this.getUniqueStr()
      // this.$emit('addAssetImg', { imgURL, fileId: this.fileId })
    },
    async onDrawHere () {
      if (this.isSaving) return

      if (this.uid !== this.slide.createdBy) {
        if (this.personalMindoScore < -10) {
          alert(`ページ内の個人のスコアが低い時はアニメーション付きの落書きを利用することができません。現在のページ内での個人のスコアは${this.personalMindoScore}です。`)
          this.currentAnimation = 'normal'
          return
        }
        if (this.animatedDoodleNum >= 50 && this.currentAnimation !== 'normal') {
          alert('これ以上このページにはアニメーション付きの落書きは追加できません。次のページからはまた追加できるようになります。')
          return
        }
      }
      this.isSaving = true

      const slideImg = this.$parent.$refs.slideImg

      const pxTop = slideImg.clientHeight + this.top
      const pxLeft = this.left
      
      const doodle = {
        type: 'image',
        imgURL: this.imgURL,
        page: this.showingPage.id,
        top: pxTop / slideImg.clientHeight * 100, // %
        left: pxLeft / slideImg.clientWidth * 100, // %
        width: this.width,
        height: this.height,
        slideImgWidth: slideImg.clientWidth,
        slideImgHeight: slideImg.clientHeight,
        animation: this.currentAnimation,
        likeNum: 0,
        dislikeNum: 0,
        likedBy: [],
        dislikedBy: [],
        createdBy: this.uid,
        createdAt: new Date(),
        updatedAt: new Date()
      }
      console.log('doodle to save', doodle)

      await database.slideCollection()
        .addDoodle(this.$route.params.slideId, doodle)
      this.$emit('resetTool')

      this.isSaving = false
    },
    cancelTool () {
      this.$emit('resetTool')
    },
    getUniqueStr (myStrong) {
      let strong = 1000
      if (myStrong) strong = myStrong
      return new Date().getTime().toString(16)  + Math.floor(strong * Math.random()).toString(16)
    },
    // base64のサイズを取得する関数
    getImageDimensions (file) {
      return new Promise (function (resolved, rejected) {
        var i = new Image()
        i.onload = function(){
          resolved({w: i.width, h: i.height})
        }
        i.src = file
      })
    },
    setCurrentAnimation (currentAnimation) {
      this.currentAnimation = currentAnimation
    }
  }
}
</script>